import PropTypes from 'prop-types';
import { WidgetPreviewContainer } from 'decap-cms-ui-default';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function TextPreview({
  value
}) {
  return _jsx(WidgetPreviewContainer, {
    children: value
  });
}
TextPreview.propTypes = {
  value: PropTypes.node
};
export default TextPreview;